import { Button, IconButton } from '@mui/material';
import { CloseIcon } from '../../../../icons';
import { useSnackbar, SnackbarKey } from 'notistack';
import { useTranslation } from 'react-i18next';
import { MutableRefObject } from 'react';
import { TooltipComponent } from '../../../atomic/feedback';

interface RemoveActionCellProps {
  employeeId: string;
  onRemoveEmployee?: (id: string) => void;
  onAddEmployee?: (id: string) => void;
  currentRemovalSnackbarRef?: MutableRefObject<SnackbarKey | null>;
}

export const RemoveActionCell = ({
  employeeId,
  onRemoveEmployee,
  onAddEmployee,
  currentRemovalSnackbarRef
}: RemoveActionCellProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleRemove = () => {
    onRemoveEmployee?.(employeeId);

    const undoAction = (snackbarId: SnackbarKey) => {
      onAddEmployee?.(employeeId);
      closeSnackbar(snackbarId);
      enqueueSnackbar(t('benefitSet:employeeRestored'), {
        variant: 'success'
      });
    };

    const snackbarId = enqueueSnackbar(t('benefitSet:employeeRemoved'), {
      variant: 'success',
      action: (snackbarId) => (
        <Button
          onClick={() => undoAction(snackbarId)}
          sx={{
            border: 'none',
            background: 'none',
            color: '#4244BE !important',
            fontSize: '14px',
            fontWeight: '400 !important',
            textTransform: 'none',
            '&:hover': {
              background: 'none'
            }
          }}
        >
          {t('benefitSet:undo')}
        </Button>
      )
    });

    if (currentRemovalSnackbarRef) {
      currentRemovalSnackbarRef.current = snackbarId;
    }
  };

  return (
    <TooltipComponent title={t('common:REMOVE')}>
      <IconButton size="small" onClick={handleRemove} color="error" aria-label={t('common:REMOVE')}>
        <CloseIcon color="grey.600" />
      </IconButton>
    </TooltipComponent>
  );
};
